import { FC } from 'react'
import { CSSTransition } from 'react-transition-group'

import { config } from 'config'
import { useNavContext } from 'context/nav-context'
import { ActiveLinkIcon } from './icons/active-link'
import { MenuIcon } from './icons/menu-icon'
import { CloseIcon } from './icons/close-icon'
import { useMenuContext } from './menu-context'
import { mainMenuCicles } from './menu-circles'
import {
  Backdrop,
  CurrentItem,
  Li,
  MainMenuItem,
  MenuList,
  MenuToggle,
} from './styled'
import { smoothScroll } from 'utils'

export const Toggle = () => {
  const { isOpen, toggleMenu } = useMenuContext()

  return (
    <MenuToggle onClick={toggleMenu} aria-label="Toggle menu">
      {isOpen ? <CloseIcon /> : <MenuIcon />}
    </MenuToggle>
  )
}

const links = [
  {
    href: config.links.homepage,
    label: 'Главная',
    key: 'homepage',
  },
  {
    href: config.links.Татары,
    label: 'Татары',
  },
  {
    href: config.links.Коми,
    label: 'Коми',
  },
  {
    href: config.links.Бурятия,
    label: 'Буряты',
    altName: 'Бурятия',
  },
  {
    href: config.links.Caxa,
    label: 'Caxa',
  },
]

export const Menu: FC<{ inverted: boolean }> = ({ inverted }) => {
  const { items, visibleItem } = useNavContext()
  const { isOpen, closeMenu } = useMenuContext()

  const scrollTo = (
    evt: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    el: HTMLElement
  ) => {
    evt.preventDefault()
    smoothScroll(el.offsetTop - 100, 100)
    closeMenu()
  }

  return (
    <>
      {isOpen && <Backdrop onClick={closeMenu} />}
      <CSSTransition timeout={500} in={isOpen}>
        <MenuList inverted={inverted}>
          {links.map(l => (
            <Li key={l.label}>
              {(l.key || l.label) === config.buildTarget ||
              l.altName === config.buildTarget ? (
                <CurrentItem>
                  <ActiveLinkIcon /> {l.label}
                </CurrentItem>
              ) : (
                <MainMenuItem
                  data-label={l.label}
                  href={l.href}
                  as={l.href ? 'a' : 'span'}
                >
                  {mainMenuCicles[l.label as keyof typeof mainMenuCicles]}
                  {l.label}
                </MainMenuItem>
              )}
              {(config.buildTarget === l.label ||
                config.buildTarget === l.altName) && (
                <ul>
                  {items.map(s => (
                    <li key={s.getAttribute('data-title')}>
                      <a
                        href="#"
                        onClick={evt => scrollTo(evt, s)}
                        data-active={visibleItem === s}
                      >
                        {s.getAttribute('data-title')}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </Li>
          ))}
        </MenuList>
      </CSSTransition>
    </>
  )
}
